import { RegisterInterestRequest, RegisterInterestResponse } from "_core/types";
import { fetchClient } from "_core/utils/fetchClient";

export const registerNewCustomer = async (
  API_URL: string,
  payload: RegisterInterestRequest
) => {
  try {
    const { message } = await fetchClient<RegisterInterestResponse>({
      base: API_URL,
      path: "/v1/register-interest/new-customer",
      options: {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      },
    });

    return message;
  } catch (error) {
    throw new Error(`Error registering new customer: ${error}`);
  }
};
